module.exports = __webpack_public_path__ + "media/images/32713-0df49065e4397a224a563d14d313d6de.png";